const mobileMaxWidth = 767
const tabletMaxWidth = 1023
const mobileNewMaxWidth = 800

const nlpMaxMobileWidth = 767
const nlpMaxTabletWidth = 1279
const nlpDesktopWidth = 1280

export default {
    data() {
        return {
            windowWidth: null,
            windowHeight: null,
        }
    },
    mounted() {
      this.getWindowWidth()
      window.addEventListener("resize", this.getWindowWidth);
    },
    beforeDestroy() {
      window.removeEventListener("resize", this.getWindowWidth);
    },
    computed: {
        isMobile() {
          return this.windowWidth <= mobileMaxWidth
        },
        isTablet() {
          return this.windowWidth >= mobileMaxWidth && this.windowWidth <= tabletMaxWidth
        },
        isDesktop() {
          return this.windowWidth >= tabletMaxWidth
        },
        isMobileNew() {
          return this.windowWidth >= mobileNewMaxWidth
        },
        isNlpDesktop() {
          return this.windowWidth >= nlpDesktopWidth
        },
        isNlpTablet() {
          return this.windowWidth > nlpMaxMobileWidth && this.windowWidth <= nlpMaxTabletWidth
        },
        isNlpMobile() {
          return this.windowWidth <= nlpMaxMobileWidth
        },
    },
    methods: {
        getWindowWidth() {
          this.windowWidth = window.innerWidth;
          this.windowHeight = window.innerHeight;
        },
    }
}
